export default "__VITE_ASSET__FISh_GLC__"